module.exports = __webpack_public_path__ + "static/media/fly0161.6d0f8b88.webp";